import { render, staticRenderFns } from "./Myquestion.vue?vue&type=template&id=451bfcc9&scoped=true&lang=html"
import script from "./Myquestion.vue?vue&type=script&lang=js"
export * from "./Myquestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451bfcc9",
  null
  
)

export default component.exports